import { FC } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { SitecoreJsonImage } from 'common/types/sitecore';
import { GNElliotWeb } from 'src/Layout';

export interface TooltipCardProps {
  image?: SitecoreJsonImage;
  title?: string;
  caption?: string;
  onMouseLeave?: () => void;
  position?: 'top' | 'bottom';
}

const TooltipCard: FC<TooltipCardProps> = ({ image, title, caption, onMouseLeave }) => {
  return (
    <div
      className="flex w-[80vw] justify-center md:w-auto"
      onMouseLeave={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onMouseLeave?.();
      }}
    >
      <div
        className={classNames(
          `relative w-4/5 rounded-2xl bg-white p-3.5 drop-shadow-xl before:hidden md:h-auto md:w-full md:max-w-[300px] md:p-5 md:pb-10 md:before:block`,
          GNElliotWeb.className
        )}
      >
        <figure>
          <div className="overflow-hidden rounded-xl">
            <Image
              className="mx-auto w-full md:max-h-[260px]"
              field={{
                ...image?.jsonValue.value,
              }}
            />
          </div>
          <figcaption className="mt-4 text-left md:mt-6">
            <h3 className="heading-6">{title}</h3>
            <p className="paragraph-small">{caption}</p>
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default TooltipCard;
